<template>
  <a-modal
    :cancel-text="a_modal.cancelText"
    :ok-text="a_modal.okText"
    :title="a_modal.title"
    v-model:open="a_modal.visible"
    wrap-class-name="full-modal"
  >
    <template #footer>
      <a-button key="back" @click="handleCancel">不同意</a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">我已阅读并同意</a-button>
    </template>
    <h2>免责协议:</h2>
    <p>1、如需实施外部救援行为(含困境，地库拖车，吊车等)，在救援师傅实施救援操作无过错的情况下，为了完成救援而导致的车辆不可避免的车辆损伤，顾客确认自行承担此类风险和损失</p>
    <p>2、确认已完全悉知本记录单服务须知第 11 点</p>
    <h2>服务须知:</h2>
    <p>1、救援师傅经救援机构授权，按照法律法规及合同内容提供道路救援服务保留不提供超出救援服务范围服务的权利。如有特殊情况，请顾客与救援机构联系</p>
    <p>2、顾客应配合救援人员检查辆外观状况并签字确认。救援机构不接受签字确认的车辆损伤情况的索赔要求3、因无法预见或人力无法抗拒的自然或人为因素(包括但不限于恶劣天气等不可抗力、交通管制、第三方事故等)造成服务延迟，导致顾客行程延误、活动取消、财产受损及人员伤害等直接或间接损失，救援师傅和救援机构不承担责任4、路边维修仅是临时性采取必要措施，使车辆恢复行使顾客应尽快前往专业车辆维修机构检测维修5、对于涉水车辆，仅提供拖车服务，将故障/事故车辆拖往修理厂或经销商处检修。如顾客要求救援师傅(或者自行或委托第三方)违反上述要求对涉水车辆进行其他操作 需要自行承担后果</p>
    <p>6、顾客如果要求自费服务项目，请与第三方协商相关费用并现场向其支付。因为此类服务发生任何争议，请与第三方或救援师傅自行解决，教援机构不再介入和负责</p>
    <p>7、拖车服务时，救援师傅仅按照救援机构的指令，将车辆拖往指定目的地，如果顾客需要变更拖车目的地，请与救援机构联系</p>
    <p>8、拖车服务时救援师傅和救援机构仅负责将故障、事故车辆拖往指定目的地顾客需采取其他方式离开现场。如果顾客坚持乘坐拖车离开顾客应自行或通过救援师傅向救援机构说明，并确认知悉搭乘风险和自愿自行承担搭乘过程中可能发生的交通事故等造成人身伤害和财损失的风险保证不以任何理由要求救援机构或救援师傅赔偿同时，顾客应保证搭乘时不干扰救援师傅驾驶救援车辆，否则，应承担全部责任9、顾客应保证车辆手续、保险齐全否则，顾客须对其因隐瞒真实情况而造成的损失等承担全部责任10、救援服务过程中，顾客不得干扰救援师傅正常工作不得要求救援师傅违反交通法规等操作和行驶，不得要求救援师傅提供一切违法和超出服务范围的服务。顾客应自行对其违法违章行为承担全部责任11、顾客应自行妥善保管车内贵重物品、车辆加装物品、可移动物品等所有物品，如发生遗失或损坏，救援师傅和道路</p>
  </a-modal>

  <div class="header" @click="backToHome">
    <LeftOutlined />
    返回
  </div>

  <div class="order">
    <div class="order-body">
      <h1>ZBCF-救援工作记录单</h1>
      <ul>
        <li>
          <label>业务类型</label>
          <div>{{ form.category_name }}</div>
        </li>
        <li>
          <label>收费类型</label>
          <div>{{ form.price_name }}</div>
        </li>
        <li>
          <label>客户名称</label>
          <div>{{ form.order_user_name }}</div>
        </li>
        <li>
          <label>订单编号</label>
          <div>{{ form.order_no }}</div>
        </li>
        <li>
          <label>救援日期</label>
          <div>{{ form.order_time }}</div>
        </li>
        <li>
          <label>车牌号</label>
          <div>{{ form.car_code }}</div>
        </li>
        <li>
          <label>车架号</label>
          <div>{{ form.car_vin }}</div>
        </li>
        <li>
          <label>车型</label>
          <div>{{ form.car_model }}</div>
        </li>
        <li>
          <label>故障</label>
          <div>{{ form.order_memo }}</div>
        </li>
        <li>
          <label>救援地</label>
          <div>
            <p>{{ form.service_start_title }}</p>
            <span>救援车辆从出发地到救援地里程<i style="color: red; font-size: 16px">{{ form.distance_depart_compute }}</i>（KM）</span>
          </div>
        </li>
        <li>
          <label>目的地</label>
          <div>
            <p>{{ form.service_end_title }}</p>
            <span>救援车辆从救援地到目的地里程<i style="color: red; font-size: 16px">{{ form.distance_compute }}</i>（KM）</span>
          </div>
        </li>
      </ul>
      <div class="agreement">
        <a-checkbox
           v-model:checked="agreement"
          @click.prevent="showModal"
        >
          我已阅读
          <a>服务须知及免责协议</a>
        </a-checkbox>
      </div>
    </div>
    <div class="order-footer">
      <a-button
        :loading="loading"
        type="primary"
        size="large"
        @click="handleSubmit('customer')"
      >
        用户签名
      </a-button>
      <a-button
        :loading="loading"
        type="primary"
        size="large"
        @click="handleSubmit('staff')"
      >
        司机签名
      </a-button>
    </div>
  </div>
</template>

<script setup>
import { Modal } from 'ant-design-vue'
import axios from 'axios'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LeftOutlined } from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()
const uuid = ref(null)
const form = ref({
  category_name: '',
  price_name: '',
  order_user_name: '',
  order_no: '',
  order_time: '',
  car_code: '',
  car_vin: '',
  car_model: '',
  service_start_title: ''
})
// const price_name = ref('')
const a_modal = ref({
  title: '服务须知及免责协议',
  visible: false
})
const agreement = ref(false)
const loading = ref(false)
const backToHome = () => {
  router.push(`/${uuid.value}`)
}
const fetchData = () => {
  return axios.get(`https://api.gdpinganxing.com/api/cs?uuid=${uuid.value}`)
}
const showModal = () => {
  a_modal.value.visible = true
  return false
}
const handleOk = () => {
  agreement.value = true
  a_modal.value.visible = false
}
const handleCancel = () => {
  agreement.value = false
  a_modal.value.visible = false
}
const handleSubmit = (role) => {
  if (!agreement.value) {
    Modal.error({
      title: '提示：',
      content: '请先阅读【服务须知及免责协议】'
    })
    return false
  }
  router.push(`/sign/${role}/${uuid.value}`)
}

onMounted(async() => {
  uuid.value = route.params.id
  const response = await fetchData()
  if (response.data.code != 200) {
    alert('获取案件信息失败...请联系客服...')
    return
  }
  const detail = response.data.data.signature.detail
  console.log(detail)
  form.value.category_name = detail.category_name
  form.value.price_name = detail.price_name
  form.value.order_user_name = detail.order_user_name
  form.value.order_no = detail.order_no
  form.value.order_time = detail.order_time
  form.value.car_code = detail.car_code
  form.value.car_vin = detail.car_vin
  form.value.car_model = detail.car_model
  form.value.order_memo = detail.order_memo
  form.value.service_start_title = detail.service_start_title
  form.value.distance_depart_compute = detail.distance_depart_compute
  form.value.service_end_title = detail.service_end_title
  form.value.distance_compute = detail.distance_compute
})
</script>

<style lang="less">
.order {
  margin-top: 58px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  width: 100vw;
  height: 100vh;
  color: #333333;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  width: 100%;
  color: #999999;
  background-color: #ffffff;
}
.full-modal {
  .ant-modal {
    top: 15px;
    bottom: 15px;
    width: calc(100% - 30px);
    height: calc(100% - 30px);
  }
  .ant-modal-content {
    height: calc(100vh - 30px);
  }
  .ant-modal-body {
    height: calc(100vh - 142px);
    overflow: scroll;
  }
}
.order-body {
  margin: 0 auto;
  overflow: scroll;
}
.order-body > h1 {
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 24px;
  text-align: center;
}
.order-body > ul {
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  padding-top: 12px;
  padding-right: 8px;
  padding-bottom: 12px;
  padding-left: 8px;
  border-top: 4px solid #cccccc;
  border-bottom: 4px solid #cccccc;
}
.order-body > ul > li {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  list-style: none;
  border-bottom: 1px dashed #cccccc;
}
.order-body > ul > li:last-child {
  border-bottom: none;
}
.order-body > ul > li::after {
  display: block;
  clear: both;
  content: '';
}
.order-body > ul > li > label {
  float: left;
  min-width: 80px;
  color: #666666;
  font-size: 14px;
  text-align: justify;
  text-align-last: justify;
}
.order-body > ul > li > label::after {
  content: '：';
}
.order-body > ul > li > div {
  float: left;
}
.order-body > ul > li > div > p {
  margin-bottom: 0;
  font-size: 15px;
}
.order-body > ul > li > div > span {
  color: #666666;
  font-size: 12px;
}
.order-body > ul > li > div > span > i {
  color: #000000;
  font-size: 14px;
}
.order-body > .agreement {
  padding-top: 8px;
  padding-bottom: 8px;
}
.order-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 20px;
  width: 100%;
}
.order-footer > button {
  margin-right: 6px;
  margin-left: 6px;
}
</style>
